'use client';

import { useEffect, useState } from 'react';

export const useCssDimensions = () => {
    const [maxWidthSm, setMaxWidthSm] = useState(false);
    const [minWidthSm, setMinWidthSm] = useState(false);
    const [minWidthMd, setMinWidthMd] = useState(false);
    const [minWidthLg, setMinWidthLg] = useState(false);
    const [minWidthXl, setMinWidthXl] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const currentInnerWidth = window.innerWidth;

            setMaxWidthSm(currentInnerWidth <= 480);
            setMinWidthSm(currentInnerWidth > 480);
            setMinWidthMd(currentInnerWidth > 768);
            setMinWidthLg(currentInnerWidth > 1024);
            setMinWidthXl(currentInnerWidth >= 1280);
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return { maxWidthSm, minWidthSm, minWidthMd, minWidthLg, minWidthXl };
};
